"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuill = _interopRequireDefault(require("react-quill"));

require("react-quill/dist/quill.snow.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var TextEditor = /*#__PURE__*/function (_Component) {
  _inherits(TextEditor, _Component);

  function TextEditor() {
    var _this;

    _classCallCheck(this, TextEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextEditor).call(this));
    _this.handleModelChange = _this.handleModelChange.bind(_assertThisInitialized(_this));
    _this.state = {
      modules: {
        toolbar: [[{
          'font': []
        }], [{
          'size': ['small', false, 'large', 'huge']
        }], [{
          'color': []
        }, {
          'background': []
        }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
          'list': 'ordered'
        }, {
          'list': 'bullet'
        }, {
          'indent': '-1'
        }, {
          'indent': '+1'
        }], ['link', 'image', 'video'], ['clean']]
      },
      formats: ['font', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image', 'video', 'color', 'background']
    };
    return _this;
  }

  _createClass(TextEditor, [{
    key: "getValidationError",
    value: function getValidationError() {
      var _this2 = this;

      var messages = [];
      this.props.handler.getErrors().filter(function (x) {
        return x.field == _this2.props.name;
      }).forEach(function (error) {
        return messages.push(error.message);
      });

      if (messages.length == 0) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: "validation-message",
        key: this.props.name + '-error'
      }, messages); // return <div className="validation-message" style={{bottom: 78, left: 48}} key={this.props.name + '-error'}>{messages}</div>;
    }
  }, {
    key: "handleModelChange",
    value: function handleModelChange(content) {
      this.setState({
        content: content
      });
    }
  }, {
    key: "setFocusOnInput",
    value: function setFocusOnInput() {
      this.setState({
        focused: true
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      if (this.props.value) {
        return;
      } else {
        this.setState({
          focused: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var validationError = this.getValidationError();
      return _react["default"].createElement("div", {
        style: {
          position: 'relative'
        }
      }, _react["default"].createElement(_reactQuill["default"], {
        value: this.props.value,
        modules: this.state.modules,
        formats: this.state.formats,
        onChange: this.props.onChange
      }), validationError);
    }
  }]);

  return TextEditor;
}(_react.Component);

exports["default"] = TextEditor;
TextEditor.defaultProps = {
  value: '',
  onChange: function onChange() {}
};